module.exports = __webpack_public_path__ + "img/automator.d8665232.png";